import React from 'react'

const StandingsRow = ({ children }) => {
  return (
    <div className="table-row">{children}</div>
  )
}

export default StandingsRow